export enum LayoutGroupName {
  GlobalTracking = 'Global Tracking',
  FacilityTracking = 'Facility Tracking',
  DispensedDrugs = 'Dispensed Drugs',
  DestroyedDrugs = 'Destroyed Drugs',
  AspireGlobalTracking = 'AspireGlobal',
  AspireFacilityTracking = 'AspireFacility',
}
